import React from 'react'
import {Icon} from '../../components/library/icon/icon'
import styled from 'styled-components'

const Wrap = styled.p`
  color: ${({theme}) => theme.red};
  display: flex;
  margin: 0 0 20px;
  gap: 10px;
  align-items: center;
`

const WarnWrap = styled.p`
  color: ${({theme}) => theme.colors.orange9};
  display: flex;
  margin: 0 0 20px;
  gap: 10px;
  align-items: center;
`

export const ErrorInfo = ({
  children,
  style
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) => (
  <Wrap style={style}>
    <Icon name="info" />
    {children}
  </Wrap>
)

export const WarnInfo = ({
  children,
  style
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) => (
  <WarnWrap style={style}>
    <Icon name="info" />
    {children}
  </WarnWrap>
)
